import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

/** Query key telling pages/reficars that this is showed when refi is selected in the service split screen. */
export const REFI_CARS_QUERY_AFTER_UPI = 'after-upi';

/**
 * When Refi is selected and there are more than one car, ask which car to loan.
 * This is used when insurance is selected and refi is not in the very first servicesplit step and then user accepts the refi cross sell.
 *
 * This step has AfterUpdatePolicyInfo suffix because originally it's different from the other reficars step in that it
 * is placed after calling updatePolicyInfo. However, now both steps are placed after updatePolicyInfo so the name is a
 * bit misleading.
 */
export const RefiCarsAfterUpdatePolicyInfoStep: Step = {
  id: 'askRefiCarsAfterUpdatePolicyInfo',
  pathname: '/reficars',
  queryParams: () => ({
    [REFI_CARS_QUERY_AFTER_UPI]: '1',
  }),
  canShow: (appData) => {
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    if (!appData.serviceSplitSelectedService?.refi && appData.selectedService?.refi) {
      if (!!appData.selectedCars && appData.selectedCars.length > 1) {
        return true;
      }
    }
    return false;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Other,
};
